































































































































































































































import { CURRENT_UNIT } from '@/queries/Application';
import { GQL_currentUnit_currentUnit } from '@/queries/__generated__/currentUnit';
import { SmartQuery } from 'vue-apollo-decorator';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Notice from './Notice.vue';
import LeftToPaySummary from './LeftToPaySummary.vue';
import SummaryMailButton from './SummaryMailButton.vue';
import {
  GQL_vacationMoneyReport,
  GQL_vacationMoneyReport_vacationMoneyReport,
  GQL_vacationMoneyReport_vacationMoneyReport_workRelation_subUnit,
} from '@/queries/__generated__/vacationMoneyReport';
import uniqBy from 'lodash/uniqBy';
import sortBy from 'lodash/sortBy';
import { GQL_settingsVacationMoneyReport } from '@/queries/__generated__/settingsVacationMoneyReport';
import { workRelationDisplay } from '@/app/WorkRelation';
import Decimal from '@/utils/decimal';
import gql from 'graphql-tag';
import { VACATION_MONEY_REPORT, VACATION_MONEY_REPORT_SETTINGS } from './queries';

const SAVE_VACATION_MONEY_REPORT_SETTINGS = gql`
  mutation saveSettingsVacationMoneyReport($settingsVacationMoneyReport: SettingsVacationMoneyReportSave!) {
    saveSettingsVacationMoneyReport(input: { settingsVacationMoneyReport: $settingsVacationMoneyReport }) {
      settingsVacationMoneyReport {
        excludePositiveAmountsTo
        excludeNegativeAmountsTo
      }
    }
  }
`;

interface ITotals {
  vacationMoneyBaseAmount: Decimal;
  vacationMoneyAmount: Decimal;
  paidReportYearAmount: Decimal;
  leftToPayReportYearAmount: Decimal;
  paidNextYearAmount: Decimal;
  leftToPayNextYearAmount: Decimal;
  leftVacationMoneyBase: Decimal;
  employersTaxAmount: Decimal;
}

@Component({
  components: {
    Notice,
    LeftToPaySummary,
    SummaryMailButton,
  },
})
export default class Report extends Vue {
  @Prop({ required: true }) private year!: number;
  @SmartQuery(CURRENT_UNIT) private currentUnit?: GQL_currentUnit_currentUnit;

  private reportData: GQL_vacationMoneyReport_vacationMoneyReport[] = [];
  private years: number[] = [];
  private settings: { excludePositiveAmountsTo: Decimal; excludeNegativeAmountsTo: Decimal } | null = null;
  private showSummary = false;
  // The PDF reads the saved settings, so don't send it while they are saving
  private savingSettings = false;

  private get nextYear(): number {
    return this.year + 1;
  }

  private get subUnits(): GQL_vacationMoneyReport_vacationMoneyReport_workRelation_subUnit[] {
    return uniqBy(this.reportData.map(report => report.workRelation.subUnit), s => s.id);
  }

  private workRelationDisplay = workRelationDisplay;

  @Watch('year')
  @Watch('currentUnit')
  public fetchSettingsAndReport(): void {
    if (!this.currentUnit) return;

    // Load the settings first, so they are created if necessary,
    // before running the report.
    this.$apollo.query({
      query: VACATION_MONEY_REPORT_SETTINGS,
      variables: { unitId: this.currentUnit.id, year: this.year },
      fetchPolicy: 'no-cache',
    }).then(({ data }: { data: GQL_settingsVacationMoneyReport }) => {
      this.settings = data.settingsVacationMoneyReport;
    }).then(() => this.fetchReport());
  }

  private fetchReport(): void {
    if (!this.currentUnit) return;

    this.$apollo.query({
      query: VACATION_MONEY_REPORT,
      variables: { unitId: this.currentUnit.id, year: this.year },
      fetchPolicy: 'no-cache',
    }).then(({ data }: { data: GQL_vacationMoneyReport }) => {
      this.reportData = sortBy(data.vacationMoneyReport, [ 'workRelation.subUnit.name', 'workRelation.employee.firstName' ]);
      // The toggle is hidden for an empty report, so an open summary would
      // be left on screen with no way to close it.
      if (!this.reportData.length) this.showSummary = false;
    });
  }

  private subUnitsWorkRelations(subUnitId: string): GQL_vacationMoneyReport_vacationMoneyReport[] {
    return this.reportData.filter(r => r.workRelation.subUnit.id === subUnitId);
  }

  private calculateTotalsForSubUnit(subUnitId: string): ITotals {
    return this.subUnitsWorkRelations(subUnitId).reduce((total, row) => {
      total.vacationMoneyBaseAmount = total.vacationMoneyBaseAmount.add(row.vacationMoneyBaseAmount);
      total.vacationMoneyAmount = total.vacationMoneyAmount.add(row.vacationMoneyAmount);
      total.paidReportYearAmount = total.paidReportYearAmount.add(row.paidReportYearAmount);
      total.leftToPayReportYearAmount = total.leftToPayReportYearAmount.add(row.leftToPayReportYearAmount);
      total.paidNextYearAmount = total.paidNextYearAmount.add(row.paidNextYearAmount);
      total.leftToPayNextYearAmount = total.leftToPayNextYearAmount.add(row.leftToPayNextYearAmount);
      total.leftVacationMoneyBase = total.leftVacationMoneyBase.add(row.leftVacationMoneyBaseAmount);
      total.employersTaxAmount = total.employersTaxAmount.add(row.employersTaxAmount);
      return total;
    }, {
      vacationMoneyBaseAmount: new Decimal(0),
      vacationMoneyAmount: new Decimal(0),
      paidReportYearAmount: new Decimal(0),
      leftToPayReportYearAmount: new Decimal(0),
      leftVacationMoneyBase: new Decimal(0),
      paidNextYearAmount: new Decimal(0),
      leftToPayNextYearAmount: new Decimal(0),
      employersTaxAmount: new Decimal(0),
    });
  }

  private saveSettings(): void {
    this.savingSettings = true;
    this.$apollo.mutate({
      mutation: SAVE_VACATION_MONEY_REPORT_SETTINGS,
      variables: {
        settingsVacationMoneyReport: {
          unitId: this.currentUnit!.id,
          year: this.year,
          ...this.settings,
        },
      },
    }).then(() => this.fetchReport())
      .finally(() => { this.savingSettings = false });
  }
}
